module.exports = __webpack_public_path__ + "static/img/tabs3.756ca04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tabs3.png
// module id = bvMg
// module chunks = 13